export default [
  {
    name: '工作台',
    path: 'home',
    icon: 'icon-home',
    hideBreadcrumb:true,
    hideSidebar: true,
    template:'base/home',
  },
  
  // {
  //   name: '可视化大屏',
  //   path: 'jsc',
  //   icon: 'icon-settings',
  //   template: 'jsc'
  // },
  
  {
    name: '园区运营',
    path: 'yunying',
    icon: 'svg-yuanquyunying',
    children:
      [
        {
          name: '运营工作台',
          path: 'yyindex',
          icon: 'icon-settings',
          template: 'yunying/yyindex',
          hideBreadcrumb: true
        },
        {
          name: 'oa办公',
          path: 'oa',
          icon: 'icon-settings',
          children:[
            {
              name: '流程申请',
              path: 'procedureRequest',
              icon: 'icon-settings',
              template: 'yunying/oa/procedureRequest'
            },
            {
              name: '待办任务',
              path: 'taskToDoHome',
              icon: 'icon-settings',
              template: 'yunying/oa/taskToDoHome',
            },
            {
              name: '我的流程',
              path: 'myProcedureHome',
              icon: 'icon-settings',
              template: 'yunying/oa/myProcedureHome',
            },
            {
              name: '已办任务',
              path: 'taskFinishedHome',
              icon: 'icon-settings',
              template: 'yunying/oa/taskFinishedHome',
            },
          ]
        },
        {
          name: '空间管理',
          path: 'space',
          icon: 'icon-settings',
          children:[
            {
              name: '楼宇管理',
              path: 'zjgl',
              icon: 'icon-settings',
              template: 'yunying/space/zjgl',
            },
            {
              name: '房源管理',
              path: 'room',
              icon: 'icon-settings',
              template: 'yunying/space/room',
            },
            {
              name: '房源分布',
              path: 'roomfb',
              icon: 'icon-settings',
              template: 'yunying/space/roomfb',
            },
            {
              name: '车位分布图',
              path: 'cwmap',
              icon: 'icon-settings',
              template: 'yunying/space/cwmap',
            }
          ]
        },
        {
          name: '合同管理',
          path: 'ktgl',
          icon: 'icon-settings',
          children:
            [
              {
                name: '合同签订',
                path: 'ktqd',
                icon: 'icon-settings',
                template: 'yunying/ktgl/ktqd'
              },
              {
                name: '合同归档',
                path: 'ktgd',
                icon: 'icon-settings',
                template: 'yunying/ktgl/ktgd'
              },
              {
                name: '合同模板',
                path: 'ktmb',
                icon: 'icon-settings',
                template: 'yunying/ktgl/ktmb'
              },
            ]
        },
        {
          name: '客户管理',
          path: 'kf',
          icon: 'icon-settings',
          children:
            [
              {
                name: '客户信息',
                path: 'kfinfo',
                icon: 'icon-settings',
                template: 'yunying/kf/kfinfo'
              },
              {
                name: '渠道管理',
                path: 'channel',
                icon: 'icon-settings',
                template: 'yunying/kf/channel'
              },
              {
                name: '入驻管理',
                path: 'lzinfo',
                icon: 'icon-settings',
                template: 'yunying/kf/lzinfo'
              },
            ]
        },
        {
          name: '资产管理',
          path: 'zs',
          icon: 'icon-settings',
          children:
            [
              {
                name: '资产管理',
                path: 'zsgl',
                icon: 'icon-settings',
                template: 'yunying/zs/zsgl',
              },
              {
                name: '资产维护管理',
                path: 'zsweibao',
                icon: 'icon-settings',
                template: 'yunying/zs/zsweibao',
              },
              {
                name: '报废处置',
                path: 'baofeicz',
                icon: 'icon-settings',
                template: 'yunying/zs/baofeicz',
              },
              {
                name: '价值管理',
                path: 'pricegl',
                icon: 'icon-settings',
                template: 'yunying/zs/pricegl',
              },
            ]
        },
        {
          name: '园区信息',
          path: 'news',
          icon: 'icon-settings',
          template: 'yunying/news'
        },
        {
          name: '园区础基信息',
          path: 'base',
          icon: 'icon-settings',
          children:
            [
              {
                name: '基本信息',
                path: 'yqbase',
                icon: 'icon-settings',
                template: 'yunying/base/yqbase'
              },
              {
                name: '停车场',
                path: 'tccar',
                icon: 'icon-settings',
                template: 'yunying/base/tccar'
              },
              {
                name: '车位管理',
                path: 'cwcar',
                icon: 'icon-settings',
                template: 'yunying/base/cwcar'
              },
              {
                name: '车位分布管理',
                path: 'cwcarmap',
                icon: 'icon-settings',
                template: 'yunying/base/cwcarmap'
              },
              {
                name: '产业信息',
                path: 'chanye',
                icon: 'icon-settings',
                template: 'yunying/base/chanye'
              },
              {
                name: '能耗管理',
                path: 'renkao',
                icon: 'icon-settings',
                template: 'yunying/base/renkao'
              },
              {
                name: '财税分析',
                path: 'csfx',
                icon: 'icon-settings',
                template: 'yunying/base/csfx'
              },
            ]
        },
        {
          name: '配制信息',
          path: 'config',
          icon: 'icon-settings',
          children:
            [
              {
                name: '信息类别',
                path: 'newstype',
                icon: 'icon-settings',
                template: 'yunying/config/newstype'
              },
              {
                name: '国资平台对接',
                path: 'guoziapi',
                icon: 'icon-settings',
                template: 'yunying/config/guoziapi'
              },
              {
                name: '渠道管理',
                path: 'kfqd',
                icon: 'icon-settings',
                template: 'yunying/config/kfqd'
              },
              
            ]
        },
      ]
  },
  {
    name: '物联系统',
    path: 'dev',
    icon: 'svg-wulianxitong',
    children:
          [
            {
              name: '物联工作台',
              path: 'devindex',
              icon: 'icon-settings',
              template: 'dev/devindex',
              hideBreadcrumb: true
            },
            {
              name: '楼层平面图',
              path: 'indoormap',
              icon: 'icon-settings',
              children:
                [
                  {
                    name: 'B1F平面图',
                    path: 'B1f',
                    icon: 'icon-settings',
                    template: 'dev/indoormap/B1f'
                  },
                  {
                    name: '1#1F平面图',
                    path: '1-1f',
                    icon: 'icon-settings',
                    template: 'dev/indoormap/1-1f'
                  },
                  {
                    name: '1#2F平面图',
                    path: '1-2f',
                    icon: 'icon-settings',
                    template: 'dev/indoormap/1-2f'
                  },
                  {
                    name: '4#1F平面图',
                    path: '4-1f',
                    icon: 'icon-settings',
                    template: 'dev/indoormap/4-1f'
                  },
                ]
            },
            {
              name: 'Ba设备',
              path: 'ba',
              icon: 'icon-settings',
              children:[
                {
                  name: '集水箱',
                  path: 'balist',
                  icon: 'icon-settings',
                  template: 'dev/ba/balist'
                },
                {
                  name: 'Ba设备显示',
                  path: 'balist2',
                  icon: 'icon-settings',
                  template: 'dev/ba/balist2'
                },
                {
                  name: '设备平面图',
                  path: 'devmap',
                  icon: 'icon-settings',
                  template: 'dev/ba/devmap'
                },
              ]
            },
            {
              name: '访客管理',
              path: 'visit',
              icon: 'icon-settings',
              children:[
                {
                  name: '访客记录',
                  path: 'visitlist',
                  icon: 'icon-settings',
                  template: 'dev/visit/visitlist'
                },
                {
                  name: '访客预约',
                  path: 'yyvisit',
                  icon: 'icon-settings',
                  template: 'dev/visit/yyvisit'
                },
                {
                  name: '被访人信息',
                  path: 'visitgl',
                  icon: 'icon-settings',
                  template: 'dev/visit/visitgl'
                },
              ]
            },
          ]
  },
  {
    name: '运维管理',
    path: 'yuweigl',
    icon: 'svg-yunweiguanli',
    children:
          [
             {
              name: '运维工作台',
              path: 'ywindex',
              icon: 'svg-yunweigongzuotai',
              template: 'yuweigl/ywindex',
              hideBreadcrumb: true
              },
            {
              name: '值班排班管理',
              path: 'zbpb',
              icon: 'svg-sijipaiban',
              children:[
                {
                  name: '值班日志',
                  path: 'dutylog',
                  icon: 'svg-zhibanrizhi',
                  template: 'yuweigl/zbpb/dutylog'
                },
                {
                  name: '值班管理',
                  path: 'zbgl',
                  icon: '📅',
                  template: 'yuweigl/zbpb/zbgl'
                },
                {
                  name: '签到记录',
                  path: 'qdlist',
                  icon: '✅',
                  template: 'yuweigl/zbpb/qdlist'
                },
                {
                  name: '班次排置',
                  path: 'bcpz',
                  icon: '⏰',
                  template: 'yuweigl/zbpb/bcpz'
                },
              ]
            },
            {
              name: '设备故障管理',
              path: 'guzhang',
              icon: '⚠️',
              children:[
                {
                  name: '设备告警',
                  path: 'alarm',
                  icon: '🔔',
                  template: 'yuweigl/dev/guzhang/alarm'
                },
                {
                  name: '设备故障',
                  path: 'devfailure',
                  icon: '❌',
                  template: 'yuweigl/dev/guzhang/devfailure'
                },
                {
                  name: '报事报修管理',
                  path: 'bsbx',
                  icon: '🛠️',
                  template: 'yuweigl/dev/guzhang/bsbx'
                },
              ]
            },
            {
              name: '工单管理',
              path: 'gongdan',
              icon: '📋',
              children:[
                {
                  name: '待办工单',
                  path: 'paidan',
                  icon: '📋',
                  template: 'yuweigl/dev/gongdan/paidan'
                },
                {
                  name: '工单池管理',
                  path: 'gdlist',
                  icon: '🗂️',
                  template: 'yuweigl/dev/gongdan/gdlist'
                },
              ]
            },
            {
              name: '设备巡检管理',
              path: 'devxunjian',
              icon: '🔍',
              children:[
                {
                  name: '巡检记录',
                  path: 'xunjianlist',
                  icon: '📋',
                  template: 'yuweigl/dev/xunjian/xunjianlist'
                },
                {
                  name: '巡检计划',
                  path: 'xunjianplan',
                  icon: '📅',
                  template: 'yuweigl/dev/xunjian/xunjianplan'
                },
                {
                  name: '巡检标准',
                  path: 'xunjianstandard',
                  icon: '📐',
                  template: 'yuweigl/dev/xunjian/xunjianstandard'
                },
                {
                  name: 'NFC位置标记卡',
                  path: 'nfcmark',
                  icon: '📍',
                  template: 'yuweigl/dev/xunjian/nfcmark'
                },
                {
                  name: '班组人员配制',
                  path: 'bzrysz',
                  icon: '👥',
                  template: 'yuweigl/dev/xunjian/bzrysz'
                },
              ]
            },
            {
              name: '设备管理',
              path: 'dev',
              icon: '⚙️',
              children:[
                {
                  name: '设备列表',
                  path: 'devlist',
                  icon: '📋',
                  template: 'yuweigl/dev/devlist'
                },
                {
                  name: '备品备件库',
                  path: 'beijian',
                  icon: '📦',
                  template: 'yuweigl/dev/beijian'
                },
                // {
                //   name: '设备故障管理',
                //   path: 'guzhanglist',
                //   icon: '⚠️',
                //   template: 'yuweigl/dev/guzhang/guzhanglist'
                // },
              ]
            },
            {
              name: '设备保养',
              path: 'devby',
              icon: '🔧',
              children:[
                {
                  name: '保养记录',
                  path: 'baoyanglist',
                  icon: '📋',
                  template: 'yuweigl/dev/bygl/baoyanglist'
                },
                {
                  name: '保养计划',
                  path: 'baoyangplan',
                  icon: '📅',
                  template: 'yuweigl/dev/bygl/baoyangplan'
                },
                {
                  name: '保养标准',
                  path: 'baoyangstandard',
                  icon: '📐',
                  template: 'yuweigl/dev/bygl/baoyangstandard'
                },
                {
                  name: '保养级别',
                  path: 'baoyanglevel',
                  icon: '🏆',
                  template: 'yuweigl/dev/bygl/baoyanglevel'
                },
              ]
            },
            {
              name: '出入库管理',
              path: 'kuchen',
              icon: '📦',
              children:[
                {
                  name: '库存管理',
                  path: 'kuchen',
                  icon: '📦',
                  template: 'yuweigl/kuchen/kuchen'
                },
                {
                  name: '出库管理',
                  path: 'chuku',
                  icon: '📤',
                  template: 'yuweigl/kuchen/chuku'
                },
                {
                  name: '入库管理',
                  path: 'luku',
                  icon: '📥',
                  template: 'yuweigl/kuchen/luku'
                },
              ]
            },
            {
              name: '运维相关配置',
              path: 'ywconfig',
              icon: '⚙️',
              children:[
                {
                  name: '设备类型',
                  path: 'devtype',
                  icon: '🏷️',
                  template: 'yuweigl/config/devtype'
                },
                {
                  name: '仓库配制',
                  path: 'wlck',
                  icon: '🏪',
                  template: 'yuweigl/config/wlck'
                },
                {
                  name: '领料部门',
                  path: 'wlbm',
                  icon: '🏢',
                  template: 'yuweigl/config/wlbm'
                },
              ]
            },
          ]
  },
  {
    name: '园区服务',
    path: 'yuanqufuwu',
    icon: 'svg-yuanqufuwu',
    children:
          [
             {
              name: '园区工作台',
              path: 'index',
              icon: 'svg-yunweigongzuotai',
              template: 'yuanqufuwu/index',
              hideBreadcrumb: true
              },
            {
              name: '基础服务',
              path: 'jcfw',
              icon: 'icon-settings',
              children: [
                {
                  name: '申请入驻',
                  path: 'qlgl',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/qlgl'
                },
                {
                  name: '物业报修',
                  path: 'wybx',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/wybx'
                },
                {
                  name: '会议室预订',
                  path: 'hysyd',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/hysyd'
                },
                {
                  name: '信息发布',
                  path: 'xxfb',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/xxfb'
                },
                {
                  name: '广告服务',
                  path: 'adinfo',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/adinfo'
                },
                {
                  name: '企业招聘',
                  path: 'zpgl',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/zpgl'
                },
                {
                  name: '共享设备预约',
                  path: 'gxsbsq',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/gxsbsq'
                },
                {
                  name: '园区商城',
                  path: 'mall',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/mall'
                },
                {
                  name: '园区社区',
                  path: 'sqgl',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/sqgl'
                },
                {
                  name: '车位预定',
                  path: 'cwyd',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/cwyd'
                },
                {
                  name: '入孵申请',
                  path: 'lfsq',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/jcfw/lfsq'
                }
              ]
            },
            {
              name: '园区活动',
              path: 'huodong',
              icon: 'icon-settings',
              children: [
                {
                  name: '活动发布',
                  path: 'hdfb',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/huodong/hdfb'
                },
                {
                  name: '活动在线报名',
                  path: 'hdbm',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/huodong/hdbm'
                },
              ]
            },
            {
              name: '培训服务',
              path: 'px',
              icon: 'icon-settings',
              children:[
                {
                  name: '培训信息管理',
                  path: 'pxgl',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/px/pxgl'
                },
                {
                  name: '培训课程',
                  path: 'pxkc',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/px/pxkc'
                },
                {
                  name: '资料库',
                  path: 'zlku',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/px/zlku'
                },
              ]
            },
            {
              name: '党群建设',
              path: 'dangqun',
              icon: 'icon-settings',
              children:
                    [
                      {
                        name: '入党申请',
                        path: 'ldsq',
                        icon: 'icon-settings',
                        template: 'yuanqufuwu/dangqun/ldsq'
                      },
                      {
                        name: '党费缴纳',
                        path: 'dflist',
                        icon: 'icon-settings',
                        template: 'yuanqufuwu/dangqun/dflist'
                      },
                      {
                        name: '关系转接',
                        path: 'gxzl',
                        icon: 'icon-settings',
                        template: 'yuanqufuwu/dangqun/gxzl'
                      },
                      {
                        name: '组织架构',
                        path: 'entity',
                        icon: 'icon-settings',
                        template: 'yuanqufuwu/dangqun/entity'
                      },
                      {
                        name: '党群资讯',
                        path: 'news',
                        icon: 'icon-settings',
                        template: 'yuanqufuwu/dangqun/news'
                      },
                    ]
            },
            {
              name: '服务对接',
              path: 'fuwudx',
              icon: 'icon-settings',
              children: [
                {
                  name: '工商税务服务',
                  path: 'gssw',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/fuwudx/gssw'
                },
                {
                  name: '法律咨询',
                  path: 'flzx',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/fuwudx/flzx'
                },
                {
                  name: '测试服务',
                  path: 'csfw',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/fuwudx/csfw'
                },
                {
                  name: '软件外包',
                  path: 'rjwb',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/fuwudx/rjwb'
                },
                {
                  name: '知识产权服务',
                  path: 'zscq',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/fuwudx/zscq'
                },
                {
                  name: '双创空间活动',
                  path: 'sckj',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/fuwudx/sckj'
                },
                {
                  name: '科技成果转换',
                  path: 'kjcg',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/fuwudx/kjcg'
                },
                {
                  name: '人才公寓申请',
                  path: 'rcgysq',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/fuwudx/rcgysq'
                },
              ]
            },
            {
              name: '物业管理系统',
              path: 'wuyegl',
              icon: 'icon-settings',
              children:
                    [
                      {
                        name: '物业设备管理',
                        path: 'sbgl',
                        icon: 'icon-settings',
                        template: 'yuanqufuwu/wuyegl/sbgl'
                      },
                      {
                        name: '物业物料管理',
                        path: 'wlgl',
                        icon: 'icon-settings',
                        template: 'yuanqufuwu/wuyegl/wlgl'
                      },
                      {
                        name: '物业收费管理',
                        path: 'sfgl',
                        icon: 'icon-settings',
                        template: 'yuanqufuwu/wuyegl/sfgl'
                      },
                      {
                        name: '物业客户服务',
                        path: 'kfgl',
                        icon: 'icon-settings',
                        template: 'yuanqufuwu/wuyegl/kfgl'
                      },
                      {
                        name: '物业合同管理',
                        path: 'ktgl',
                        icon: 'icon-settings',
                        template: 'yuanqufuwu/wuyegl/ktgl'
                      },
                    ]
            },
            {
              name: '园区服务配制',
              path: 'config',
              icon: 'icon-settings',
              children: [
                {
                  name: '企业上报数据',
                  path: 'qysb',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/config/qysb'
                },
                {
                  name: '共享设备管理',
                  path: 'gxsbgl',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/config/gxsbgl'
                },
                {
                  name: '会议室管理',
                  path: 'hysgl',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/config/hysgl'
                },
                {
                  name: '外部商城',
                  path: 'wbsc',
                  icon: 'icon-settings',
                  template: 'yuanqufuwu/config/wbsc'
                },
              ]
            },
          ]
  },
  {
    name: '在线消费',
    path: 'onlineshop',
    icon: 'svg-onlineshop',
    children: [
      {
        name: '消费工作台',
        path: 'index',
        icon: 'svg-yunweigongzuotai',
        template: 'onlineshop/index',
        hideBreadcrumb: true
      },
      {
        name: '商品管理',
        path: 'spgl',
        icon: 'icon-settings',
        template: 'onlineshop/spgl'
      },
      {
        name: '商品类别',
        path: 'sptype',
        icon: 'icon-settings',
        template: 'onlineshop/sptype'
      },
      {
        name: '消费设备管理',
        path: 'gzlist',
        icon: 'icon-settings',
        template: 'onlineshop/gzlist'
      },
      {
        name: '商家管理',
        path: 'sjlist',
        icon: 'icon-settings',
        template: 'onlineshop/sjlist'
      },
      {
        name: '订单管理',
        path: 'ddlist',
        icon: 'icon-settings',
        template: 'onlineshop/ddlist'
      },
      {
        name: '广告管理',
        path: 'adgl',
        icon: 'icon-settings',
        template: 'onlineshop/adgl'
      },
      {
        name: '营销促销',
        path: 'promo',
        icon: 'icon-settings',
        template: 'onlineshop/promo'
      },
      {
        name: '售后退款',
        path: 'refund',
        icon: 'icon-settings',
        template: 'onlineshop/refund'
      },
      {
        name: '物流配送',
        path: 'wlps',
        icon: 'icon-settings',
        template: 'onlineshop/wlps'
      },
      {
        name: '经营报表',
        path: 'report',
        icon: 'icon-settings',
        template: 'onlineshop/report'
      }
    ]
  },
  {
    name: '产业链',
    path: 'chanyelian',
    icon: 'svg-chanyelian',
    children:
          [
             {
              name: '产业链工作台',
              path: 'cyindex',
              icon: 'icon-settings',
              template: 'chanyelian/cyindex',
              hideBreadcrumb: true
              },
            {
              name: '协同制造',
              path: 'xtzz',
              icon: 'svg-xtzz',
              children: [
                {
                  name: '计划管理',
                  path: 'jfgl',
                  icon: 'icon-settings',
                  template: 'chanyelian/xtzz/jfgl'
                },
                {
                  name: '生产管理',
                  path: 'scgl',
                  icon: 'icon-settings',
                  template: 'chanyelian/xtzz/scgl'
                },
                {
                  name: '质量管理',
                  path: 'zlgl',
                  icon: 'icon-settings',
                  template: 'chanyelian/xtzz/zlgl'
                },
                {
                  name: '物流管理',
                  path: 'wlgl',
                  icon: 'icon-settings',
                  template: 'chanyelian/xtzz/wlgl'
                },
                {
                  name: '协同设备',
                  path: 'xtsb',
                  icon: 'icon-settings',
                  template: 'chanyelian/xtzz/xtsb'
                },
                {
                  name: '企业生产',
                  path: 'qysc',
                  icon: 'icon-settings',
                  template: 'chanyelian/xtzz/qysc'
                },
              ]
            },
            {
              name: '一体产业链',
              path: 'yiticy',
              icon: 'svg-yiticy',
              children: [
                {
                  name: '商机发布',
                  path: 'sjfb',
                  icon: 'icon-settings',
                  template: 'chanyelian/yiticy/sjfb'
                },
                {
                  name: '集采发布',
                  path: 'jcfb',
                  icon: 'icon-settings',
                  template: 'chanyelian/yiticy/jcfb'
                },
                {
                  name: '库存管理',
                  path: 'kcgl',
                  icon: 'icon-settings',
                  template: 'chanyelian/yiticy/kcgl'
                },
                {
                  name: '企业合作',
                  path: 'qykz',
                  icon: 'icon-settings',
                  template: 'chanyelian/yiticy/qykz'
                },
              ]
            },
          ]
  },
  {
    name: 'BIM可视化',
    path: 'bim',
    icon: 'svg-bim',
    template: 'bim'
  },
  {
    name: '系统设置',
    path: 'system',
    icon: 'svg-system',
    template:'',
    children: [
      // {
      //   name: '系统工作台',
      //   path: 'workplace',
      //   icon: 'icon-dashboard',
      //   hideBreadcrumb:true,
      //   template: 'base/workplace'
      // },
      {
        name: '个人中心',
        path: 'usercenter',
        icon: 'icon-user',
        template: 'base/usercenter'
      },
      // {
      //   name: '大屏展示',
      //   path: 'dp',
      //   icon: 'icon-settings',
      //   hideBreadcrumb:true,
      //   children:[
      //     {
      //       name: '大屏1',
      //       path: 'dp1',
      //       icon: 'svg-apps-fill',
      //       template: 'base/dp1'
      //     },
      //     {
      //       name: '大屏2',
      //       path: 'dp2',
      //       icon: 'icon-settings',
      //       template: 'base/dp2'
      //     },
      //     {
      //       name: 'test',
      //       path: 'test1',
      //       icon: 'icon-settings',
      //       template: 'base/test'
      //     },
      //     {
      //       name: '大屏21',
      //       path: 'dp22',
      //       icon: 'icon-settings',
      //       template: 'base/test5'
      //     },
      //   ]
      // },
      
      
      {
        name: '用户管理',
        path: 'userlist',
        icon: 'icon-settings',
        template: 'base/userlist'
      },
      {
        name: '机构部门',
        path: 'entity',
        icon: 'icon-settings',
        template: 'base/entity'
      },
      {
        name: '角色管理',
        path: 'rolelist',
        icon: 'icon-settings',
        template: 'base/rolelist'
      },
      {
        name: '菜单管理',
        path: 'menulist',
        icon: 'icon-settings',
        template: 'base/menulist'
      },
      // {
      //   name: '作业票',
      //   path: 'tlspadd',
      //   icon: 'icon-history',
      //   template: 'tlsp/tlspadd'
      // },
      {
        name: '登陆日志',
        path: 'userlog',
        icon: 'icon-history',
        template: 'base/userlog'
      },
      {
        name: '字典库',
        path: 'systemoption',
        icon: 'icon-list',
        template: 'base/systemoption'
      },
      // {
      //   name: '帮助中心',
      //   path: 'help',
      //   icon: 'icon-question-circle',
      //   template: 'base/help'
      // },
      {
        name: '帮助内容',
        path: 'helpadmin',
        icon: 'icon-edit',
        template: 'base/helpadmin'
      },
      // {
        //   name: '字典库2',
      //   path: 'dict',
      //   icon: 'icon-folder',
      //   template:'base/dict',
      //   showChild: false, 
      //   children:
      //     [
      //       {
      //         name: '数据列表21',
      //         path: 'dictlist',
      //         icon: 'icon-settings',
      //         template: 'base/dictlist'
      //       },
      //       {
      //         name: '数据列表22',
      //         path: 'd3',
      //         icon: 'icon-settings',
      //         template: 'base/test4',
      //       },
      //     ]
      // },
    ]
  },
]